const route = [
    {
        path: '/activity/2023qm/index', //2023下期末检测
        component: function (resolve) {
            require(['VIEWS/activity/2023qm/index.vue'], resolve);
        }
    },
]
export default route;
